import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import VueAnalytics from 'vue-analytics'

import utils from './etc/utils'
// import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      userId: '',
      userName: '',
      role: '',
      level: 0
    },
    company: {},
    boardMetas: [],
    menus: {},
    banners: {
      normal: [],
      top: []
    },
    designPost: {
      seq: {},
      key: {}
    }
  },
  mutations: {
    SET_USER_INFO: (state, payload) => {
      const { userId, userName, role, email, avatar } = payload

      state.user = {
        userId,
        userName,
        role,
        level: utils.getLevel(role),
        email,
        avatar
      }
    },
    SET_BOARD_META: (state, payload) => {
      const boardMetas = payload.reduce((acc, row) => {
        row.fieldMetaMap = row.fieldMeta.reduce((acc, meta) => {
          acc[meta.fieldId] = meta
          return acc
        }, {})
        acc[row.boardId] = row
        return acc
      }, {})
      console.log('boardMetas', boardMetas)
      state.boardMetas = boardMetas
    },
    SET_COMPANY: (state, payload) => {
      state.menus = payload.menus
      console.log('payload.menus', payload.menus)
      state.company = payload

      state.company.theme.mobileContainer = {
        ...state.company.theme.userContainer,
        ...state.company.theme.mobileContainer
      }
      delete state.company.menus

      document.title = state.company.companyName

      // if (state.company.favicons && state.company.favicons.length > 0) {
      {
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = '/api/companys/me/images/favicon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      // console.log('state.company', state.company)
      // console.log('state.menus', state.menus)
    },
    SET_BANNER: (state, payload) => {
      state.banners.normal = payload.filter(banner => banner.bannerType === 'normal')
      state.banners.top = payload.filter(banner => banner.bannerType === 'top')
      state.banners.quick = payload.filter(banner => banner.bannerType === 'quick')
      console.log('state.banners', state.banners)
    },
    // SET_DESIGN_POST: (state, payload) => {
    //   state.designPost = {
    //     ...state.designPost,
    //     [payload.seq]: payload
    //   }
    // },
    SET_ALL_DESIGN_POSTS: (state, payload) => {
      state.designPost.seq = payload.rows.reduce((acc, post) => {
        acc[post.seq] = post
        return acc
      }, {})
      state.designPost.key = payload.rows.reduce((acc, post) => {
        if (post.key) {
          acc[post.key] = post
        }
        return acc
      }, {})
    }
  },
  actions: {
    GET_ME: async store => {
      try {
        const res = await axios.get('/api/users/me')
        store.commit('SET_USER_INFO', res.data)
      } catch (ex) {
        console.error(ex, ex.response)
        store.commit('SET_USER_INFO', {})
      }

      // try {
      //   const res = await Promise.all([axios.get('/api/board-metas'), axios.get('/api/companys/me')])
      //   store.commit('SET_BOARD_META', res[0].data)
      //   store.commit('SET_COMPANY', res[1].data)
      // } catch (ex) {
      //   console.error(ex, ex.response)
      //   store.commit('SET_BOARD_META', [])
      //   store.commit('SET_COMPANY', {})
      // }
    },
    LOGOUT: async store => {
      try {
        await axios.post('/api/logout')
      } catch (ex) {
        console.error(ex, ex.response)
      } finally {
        store.commit('SET_USER_INFO', {})
      }
    }
    // DESIGN_POST: async ({ commit, state }, payload) => {
    //   console.log('--------.. state', state.designPost, payload)

    //   const res = await axios.get(`/api/boards/design/seqs/${payload.seq}`)
    //   commit('SET_DESIGN_POST', res.data)
    // }
  }
})
